import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../distributerMaster/distributerMaster.scss";
import FetchData, { DeleteEntry, GetList } from "../../providers/dataProvider";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import DataFilter from "../../utils/DataFilter";
import DataSearch from "../../utils/DataSearch";
import { useRolePermission } from "../../hooks/useRolePermission";
import DeleteModal from "../../components/common/DeleteModal";
import ErrorMessage from "../../components/common/ErrorMessage";
import { CheckNull } from "../../utils/Validate";
import DistributerMasterFilter from "../../components/distributerMaster/DistributerMasterFilter";
import DistributerMasterGrid from "../../components/distributerMaster/DistributerMasterGrid";
import { SearchComponent } from "../../components/common/SearchComponent";
import AdvancedFilterDropdown from "../../components/common/AdvancedFilterDropdown";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";

const statusOptions = [
  { value: "true", label: "Active" },
  { value: "false", label: "Inactive" },
];
const DistributerMasterList = () => {
  const navigate = useNavigate();
  const [distributorData, setDistributorData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [deleteShow, setDeleteShow] = useState({
    show: false,
    item: "",
    title: "",
    textCode: "",
    text: "",
    loading: false,
  });

  const [companyName, setCompanyName] = useState([]);
  const [assignedEngineer, setAssignedEngineer] = useState([]);
  const [search, setSearch] = useState("");
  const [distributorFilter, setDistributorFilter] = useState({
    companyName: [],
    type: [],
    assignedEngineerName: [],
    status: [],
  });
  const [status, setStatus] = useState([]);
  const [type, setType] = useState([]);
  const [clrFilter, setClrFilter] = useState(false);
  const [filterColumn, setFilterColumn] = useState([]);
  const [selected, setSelected] = useState([]);
  const [refreshSearch, setRefreshSearch] = useState(false);
  const [successShow, setSuccessShow] = useState(false);
  const [createMsg, setCreateMsg] = useState(null);
  const [listData, setListData] = useState(null);
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: "",
  });
  
  const { menuRights } = useRolePermission("Distributor Master");

  const baseColumns = [
    {
      heading: "Distributor Name",
      value: "distributorName",
      sortable: true,
    },
    {
      heading: "Company Name",
      value: "companyName",
      sortable: true,
    },
    {
      heading: "Assigned Engineer",
      value: "assignedEngineerName",
      sortable: true,
    },
    {
      heading: "Country",
      value: "countryName",
      sortable: true,
    },
    {
      heading: "Status",
      value: "status",
      sortable: true,
    },
  ];

  const {
    data: distributorList,
    loading: loadingList,
    error,
  } = FetchData("distributor");
  const { data: companyList } = FetchData("company");
  const { data: countrydata } = FetchData("country");
  const { data: distributorTypeList } = FetchData("distributorType");
  const { data: assignedEngineerList } = FetchData("userprofile");

  useEffect(() => {
    let filterdata = distributorData.map((filterItem, index) => {
      let countryName = "";
      let companyName = "";
      let assignedEngineerName = "";
      var countryValue = countrydata.filter(function (item) {
        return item.id === filterItem.countryId;
      });
      const companyObject = companyList?.find(
        (item) => item?.id == filterItem?.companyId
      );
      const engineerObject = assignedEngineerList?.find(
        (item) => item?.identityId == filterItem?.assignedEngineerId
      );
      if (companyObject) companyName = companyObject?.companyName;
      if (countryValue) countryName = countryValue[0]?.name;
      if (engineerObject)
        assignedEngineerName =
          engineerObject?.firstName + " " + engineerObject?.lastName;
      filterItem.countryName = countryName;
      filterItem.companyName = companyName;
      filterItem["assignedEngineerName"] = assignedEngineerName;
      filterItem.status = filterItem.isActive === true ? "Active" : "Inactive";
      filterItem["view"] = menuRights?.canView === true ? "VIEW" : "NOT-VIEW";
      return filterItem;
    });
    filterdata = [...filterdata]?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
    if (search != "") ApplySearch();
    else setTableData(filterdata);
  }, [
    distributorData,
    countrydata,
    companyList,
    assignedEngineerList,
    menuRights,
  ]);

  useEffect(() => {
    if (distributorList) setDistributorData(distributorList);
  }, [distributorList]);

  const handleChange = (e, index) => {
    const activeData = document.getElementById(index).checked;
    if (activeData == false) {
      setSelected((oldData) => [...oldData, e.target.value]);
    } else {
      setSelected(selected.filter((values) => values !== e.target.value));
    }
  };

  useEffect(() => {
    let value = baseColumns.filter(({ value }) => !selected.includes(value));
    setFilterColumn(value);
  }, [selected]);


  //Filter
  const handleLabelFilterChange = (selectedOption, params) => {
    if (params === "companyName") setCompanyName(selectedOption)
    if (params === "assignedEngineerName") setAssignedEngineer(selectedOption)
    if (params === "type") setType(selectedOption)
    if (params === "status") setStatus(selectedOption)
    setDistributorFilter({ ...distributorFilter, [params]: selectedOption?.label });
  };

  const handleEdit = (item) => {
    if (item)
      navigate("/add-new-distributor", {
        state: {
          row: item,
          id: item?.id,
          canAdd: menuRights?.canAdd,
          canEdit: menuRights?.canEdit,
        },
      });
  };

  const handleDelete = (item) => {
    setDeleteShow({
      show: true,
      item: item,
      title: "You want delete this Distributor?",
      textCode: "Distributor Name",
      text: item?.distributorName,
      loading: false,
    });
  };

  const handleCancelDelete = () => {
    setDeleteShow({
      show: false,
      item: "",
      title: "",
      textCode: "",
      text: "",
      loading: false,
    });
  };

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);
  };

  const handleConfirmDelete = (item) => {
    setDeleteShow({
      ...deleteShow,
      loading: true,
    });
    DeleteEntry(
      "distributor",
      item,
      setCreateMsg,
      "Distributor deleted successfully",
      "Failed to delete distributor"
    );
  };

  useEffect(() => {
    if (createMsg?.successData === "Successful") {
      if (CheckNull(createMsg?.message) !== "") {
        setDeleteShow({
          show: false,
          item: "",
          title: "",
          textCode: "",
          text: "",
          loading: false,
        });
        setSuccessShow(true);
      }
    } else {
      if (CheckNull(createMsg?.message) !== "") {
        setDeleteShow({
          show: false,
          item: "",
          title: "",
          textCode: "",
          text: "",
          loading: false,
        });
        setErrorShow({ show: true, errorMessage: createMsg.message });
        setSuccessShow(false);
      }
    }
  }, [createMsg]);

  const ClearFilter = () => {
    setDistributorFilter({
      companyName: [],
      type: [],
      status: [],
      assignedEngineerName: [],
    });
    setCompanyName([]);
    setType([]);
    setStatus([]);
    setAssignedEngineer([]);
    setClrFilter(true);
  };

  const RefreshList = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (clrFilter === true) ApplyFilter();
  }, [clrFilter]);

  const ApplyFilter = () => {
    let filterResult = [];
    filterResult = DataFilter(distributorData, distributorFilter);
    filterResult = DataSearch(filterResult, search, baseColumns);
    filterResult = [...filterResult]?.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    setTableData(filterResult);
    setClrFilter(false);
  };

  const ApplySearch = () => {
    let SearchResult = [];
    SearchResult = DataSearch(distributorData, search, baseColumns);
    SearchResult = DataFilter(SearchResult, distributorFilter);
    SearchResult = [...SearchResult]?.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    setTableData(SearchResult);
    setRefreshSearch(false);
  };

  useEffect(() => {
    if (refreshSearch === true || search == "") ApplySearch();
  }, [search]);

  const removeSearch = () => {
    setSearch("");
    setRefreshSearch(true);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      ApplySearch();
    }
  };

  const addNew = () => {
    navigate("/add-new-distributor", {
      state: {
        canAdd: menuRights?.canAdd,
        canEdit: menuRights?.canEdit,
      },
    });
  };

  const SuccessDoneListClick = () => {
    setSuccessShow(false);
    if (createMsg?.message == "Distributor deleted successfully")
      GetList("distributor", "", setListData);
  };

  useEffect(() => {
    if (listData?.message == "success") {
      setDistributorData(listData?.data);
    }
  }, [listData]);

  const handleView = (item) => {
    menuRights?.canView &&
      navigate("/view-distributor", {
        state: item,
        canView: menuRights?.canView,
      });
  };
  const hasActiveFilters = Boolean(
    companyName?.value || assignedEngineer?.value || type?.value || status?.value
  );

  return (
    <>
      <section className="distributer-master-list-sec" id="distributerMasterList">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 py-1">
              <div className="card">
                <div className="card-body">
                  <div className="row search-area-row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto p-0">
                      <div>
                        <p>{tableData?.length} Results Found</p>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 my-auto p-0">
                      <SearchComponent
                        filteredResults={tableData}
                        search={search}
                        handleKeyDown={handleKeyPress}
                        setSearch={setSearch}
                        removeSearch={removeSearch}
                        ApplySearch={ApplySearch}
                        RefreshList={RefreshList}
                        baseColumns={baseColumns}
                        selected={selected}
                        handleChange={handleChange}
                        data={distributorList}
                        addNew={addNew} 
                        menuRights={menuRights}
                        hasActiveFilters={hasActiveFilters}
                        filterContent={(closeFilter) => (
                          <AdvancedFilterDropdown
                            ApplyFilter={ApplyFilter}
                            ClearFilter={ClearFilter}
                            onCloseFilter={closeFilter}
                            startWithFirstOnly
                            fields={[
                              {
                                value: "companyName",
                                label: "Company",
                                placeholder: PlaceHolder.SELECT_COMPANY,
                                pageName: "DistributorList",
                                dpDownName: "company",
                                data: companyList,
                                valueObject: companyName,
                                valueId: distributorFilter?.companyName,
                                setState: setCompanyName,
                                checkLabel: true,
                                onChange: (e) => handleLabelFilterChange(e, "companyName"),
                              },
                              {
                                value: "assignedEngineerName",
                                label: "Assigned Engineer",
                                placeholder: PlaceHolder.SELECT_ASSIGNED,
                                pageName: "DistributorList",
                                dpDownName: "salesengineer",
                                data: assignedEngineerList,
                                valueObject: assignedEngineer,
                                valueId: distributorFilter?.assignedEngineerName,
                                setState: setAssignedEngineer,
                                checkLabel: true,
                                onChange: (e) => handleLabelFilterChange(e, "assignedEngineerName"),
                              },
                              {
                                value: "type",
                                label: "Distributor Type",
                                placeholder: PlaceHolder.SELECT_DISTRIBUTOR_TYPE,
                                pageName: "DistributorList",
                                dpDownName: "distributorTypesdrp",
                                data: distributorTypeList,
                                valueObject: type,
                                valueId: distributorFilter?.type,
                                setState: setType,
                                checkLabel: true,
                                onChange: (e) => handleLabelFilterChange(e, "type"),
                              },
                              {
                                value: "status",
                                label: "Status",
                                placeholder: PlaceHolder.SELECT_STATUS,
                                pageName: "DistributorList",
                                dpDownName: "status",
                                data: statusOptions,
                                valueObject: status,
                                valueId: distributorFilter?.status,
                                setState: setStatus,
                                checkLabel: true,
                                onChange: (e) => handleLabelFilterChange(e, "status"),
                              },
                            ]}
                          />
                        )} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <DistributerMasterGrid
            filteredResults={tableData}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleView={handleView}
            loading={loadingList}
            menuRights={menuRights}
            moduleName='distributor' />
        </div>
      </section>
      {/* <!-- filter modal start--> */}

      <DistributerMasterFilter
        type={type}
        status={status}
        setType={setType}
        setStatus={setStatus}
        assignedEngineer={assignedEngineer}
        companyName={companyName}
        setCompanyName={setCompanyName}
        statusOptions={statusOptions}
        ClearFilter={ClearFilter}
        ApplyFilter={ApplyFilter}
        distributorFilter={distributorFilter}
        companyList={companyList}
        handleLabelFilterChange={handleLabelFilterChange}
        setAssignedEngineer={setAssignedEngineer}
        assignedEngineerList={assignedEngineerList}
        distributorTypeList={distributorTypeList} />

      {/*<!--  deleteModal start--> */}
      <DeleteModal deleteShow={deleteShow} handleCancelDelete={handleCancelDelete} handleConfirmDelete={handleConfirmDelete} />
      <ErrorMessage Show={errorShow?.show} errorMessage={errorShow?.errorMessage} ErrorDoneClick={ErrorDoneClick} />
      <SaveSuccessModel show={successShow} createMsg={createMsg} setShow={setSuccessShow} SuccessDoneClick={SuccessDoneListClick} />
    </>
  );
};

export default DistributerMasterList;
